import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { useGetSmsSummaryMetrics } from 'infrastructure/hooks/sms-metrics/use-get-sms-summary-metrics';
import colors from 'assets/styles/colors';

import SmsMetricsPieChart from '../pie-chart';

import type { ISmsMetricsFilters } from 'infrastructure/interfaces';

interface IProps {
  filter: ISmsMetricsFilters;
}

const colorMap: Record<string, string> = {
  failed: colors.blue50,
  queued: colors.purple50,
  received: colors.orange50,
  sent: colors.yellow50,
  delivered: colors.green50,
  undelivered: colors.red50,
};

const SmsStatusOverviewPieChart: React.FC<IProps> = (props) => {
  const { filter } = props;

  const { t } = useTranslation();

  const { data, isLoading } = useGetSmsSummaryMetrics(filter, 'status');

  const mappedData = useMemo(() => {
    return data.map((el) => {
      const name = t(`smsStatuses.${el.status}` as any);
      return {
        value: el.count,
        name,
        color: colorMap[el.status],
      };
    });
  }, [data, isLoading]);

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <SmsMetricsPieChart
        title={t('labels.statusOverview')}
        data={mappedData}
      />
    </BaseSpinWrapper>
  );
};

export default SmsStatusOverviewPieChart;
